import globalApi from "../lib/global-api";
import wrapPromise from "./wrap-prmise";




function fetchDataWithPromise(url) {
  // Can use axios too
  const promise = globalApi({url});

  //console.log(promise);  

  return wrapPromise(promise);
}
export function fetchDataWithPromiseAndStoreData(url) {
  // Can use axios too
  const promise = globalApi({url});

  //console.log(promise);  

  return {
    promise,
    wrapPromise:  wrapPromise(promise)};
}

export default fetchDataWithPromise;